import React from "react"
import { Navigate } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Pages Calendar
import Calendar from "../pages/Calendar/index"

//Email
import EmailInbox from "../pages/Email/email-inbox"
import EmailRead from "../pages/Email/email-read"
import EmailCompose from "../pages/Email/email-compose"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login"
import Register1 from "../pages/AuthenticationInner/Register"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"
import BlockedIp from "../pages/BlockedIp"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import DashboardSwitcher from "../pages/Dashboard/DashboardSwitcher";

//Charts
import ChartsAppex from "../pages/Charts/charts-appex";
import ChartsJs from "../pages/Charts/charts-chartjs";
import ChartsKnob from "../pages/Charts/charts-knob";
import ChartsSparkLine from "../pages/Charts/charts-sparkline";

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle"
import MapsVector from "../pages/Maps/MapsVector"

//Icons
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign"
import Iconion from "../pages/Icons/Iconion"
import IconFontawesome from "../pages/Icons/IconFontawesome"
import IconThemify from "../pages/Icons/IconThemify"
import IconDripicons from "../pages/Icons/IconDripicons"
import IconTypicons from "../pages/Icons/IconTypicons"

//Tables
import BasicTables from "../pages/Tables/BasicTables"
import DatatableTables from "../pages/Tables/DatatableTables"
import ResponsiveTables from "../pages/Tables/ResponsiveTables"

// Forms
import FormElements from "../pages/Forms/FormElements"
import FormAdvanced from "../pages/Forms/FormAdvanced"
import FormEditors from "../pages/Forms/FormEditors"
import FormValidations from "../pages/Forms/FormValidations"
import FormUpload from "../pages/Forms/FormUpload"

//Ui
import UiAlert from "../pages/Ui/UiAlert"
import UiButtons from "../pages/Ui/UiButtons"
import UiBadge from "../pages/Ui/UiBadge"
import UiCards from "../pages/Ui/UiCards"
import UiCarousel from "../pages/Ui/UiCarousel"
import UiDropdown from "../pages/Ui/UiDropdown"
import UiGrid from "../pages/Ui/UiGrid"
import UiImages from "../pages/Ui/UiImages"
import UiLightbox from "../pages/Ui/UiLightbox"
import UiModal from "../pages/Ui/UiModal"
import UiPagination from "../pages/Ui/UiPagination"
import UiPopoverTooltips from "../pages/Ui/UiPopoverTooltips"
import UiProgressbar from "../pages/Ui/UiProgressbar"
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions"
import UiTypography from "../pages/Ui/UiTypography"
import UiVideo from "../pages/Ui/UiVideo"
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout"
import UiRangeSlider from "../pages/Ui/UiRangeSlider"

//Extra Pages
import PagesTimeline from "../pages/Extra Pages/pages-timeline";
import PagesInvoice from "../pages/Extra Pages/pages-invoice";
import PagesDirectory from "../pages/Extra Pages/pages-directory";
import PagesBlank from "../pages/Extra Pages/pages-blank";
import Pages404 from "../pages/Extra Pages/pages-404";
import Pages500 from "../pages/Extra Pages/pages-500";
import UiUtilities from "pages/Ui/UiUtilities"
import UiColors from "pages/Ui/UiColors"
import UiOffcanvas from "pages/Ui/UiOffcanvas"
import Chat from "pages/Chat/Chat";
import Kanban from "pages/Kanban"

// Institutions
import InstitutionsList from "../pages/Institutions/List";
import CreateInstitution from "../pages/Institutions/Create";
import EditInstitution from "../pages/Institutions/Edit";
import InstitutionsCards from '../pages/Institutions/InstitutionsCards';
import PrintInstitutionView from "../pages/Institutions/PrintInstitutionView";

// Journalists
import CreateJournalist from "../pages/Journalists/Create";
import JournalistsList from "../pages/Journalists/JournalistsList";
import EditJournalist from "../pages/Journalists/Edit";
import JournalistsCards from '../pages/Journalists/JournalistsCards';
import PrintJournalistView from "../pages/Journalists/PrintJournalistView";

// Activists
import CreateActivist from "../pages/Activists/CreateActivist";
import ActivistsList from "../pages/Activists/ActivistsList";
import EditActivist from "../pages/Activists/EditActivist";
import ViewActivist from "../pages/Activists/ViewActivist"; // ✅ الإضافة الجديدة
import ViewJournalist from "../pages/Journalists/ViewJournalist";
import ViewInstitution from "../pages/Institutions/ViewInstitution";
import UserViewActivist from "../pages/Activists/UserViewActivist";
import PrintActivistView from "../pages/Activists/PrintActivistView";


// Users
import UsersList from '../pages/UsersList';
import UserEdit from '../pages/UserEdit';
import ActivistsCards from '../pages/Activists/ActivistsCards';
import UserCreate from '../pages/UserCreate'; // added
import RoleGuard from '../components/RoleGuard'; // ✅ جديد
import Whitelist from '../pages/Settings/Whitelist';

// Approvals
import PendingApprovals from '../pages/Approvals/PendingApprovals';
import PendingApprovalDetail from '../pages/Approvals/PendingApprovalDetail';
import ApprovalLogs from '../pages/Approvals/ApprovalLogs';
import MyRequests from '../pages/Approvals/MyRequests';



const userRoutes = [
  { path: "/dashboard", component: <DashboardSwitcher /> }, // ✅ استبدال حسب الدور

  // //calendar
  { path: "/calendar", component: <Calendar /> },

  { path: "/chat", component: <Chat /> },
  { path: "/kanbanboard", component: <Kanban /> },

  // // //profile
  { path: "/profile", component: <UserProfile /> },

  // //Email
  { path: "/email-inbox", component: <EmailInbox /> },
  { path: "/email-read", component: <EmailRead /> },
  { path: "/email-compose", component: <EmailCompose /> },

  // //Charts
  { path: "/apex-charts", component: <ChartsAppex /> },
  { path: "/charts-chartjs", component: <ChartsJs /> },
  { path: "/charts-knob", component: <ChartsKnob /> },
  { path: "/sparkline-charts", component: <ChartsSparkLine /> },

  // // Icons
  { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  { path: "/icons-ion", component: <Iconion /> },
  { path: "/icons-fontawesome", component: <IconFontawesome /> },
  { path: "/icons-themify", component: <IconThemify /> },
  { path: "/icons-dripicons", component: <IconDripicons /> },
  { path: "/icons-typicons", component: <IconTypicons /> }, 
  
  // // Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-datatable", component: <DatatableTables /> },
  { path: "/tables-responsive", component: <ResponsiveTables /> },

  // // Maps
  { path: "/maps-google", component: <MapsGoogle /> },
  { path: "/maps-vector", component: <MapsVector /> },

  // // Forms
  { path: "/form-elements", component: <FormElements /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-validation", component: <FormValidations /> },

  // // Ui
  { path: "/ui-alerts", component: <UiAlert /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-badge", component: <UiBadge /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-dropdowns", component: <UiDropdown /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-lightbox", component: <UiLightbox /> },
  { path: "/ui-modals", component: <UiModal /> },
  { path: "/ui-pagination", component: <UiPagination /> },
  { path: "/ui-popover-tooltip", component: <UiPopoverTooltips /> },
  { path: "/ui-progressbars", component: <UiProgressbar /> },
  { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  { path: "/ui-utilities", component: <UiUtilities /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },

  // //Extra Pages
  { path: "/pages-timeline", component: <PagesTimeline /> },
  { path: "/pages-invoice", component: <PagesInvoice /> },
  { path: "/pages-directory", component: <PagesDirectory /> },
  { path: "/pages-blank", component: <PagesBlank /> },
  
  // Institutions Routes (admin + data_entry)
  { path: "/dashboard/institutions", component: <RoleGuard roles={['admin','data_entry']}><InstitutionsList /></RoleGuard> },
  { path: "/dashboard/institutions/create", component: <RoleGuard roles={['admin','data_entry']}><CreateInstitution /></RoleGuard> },
  { path: "/dashboard/institutions/edit/:id", component: <RoleGuard roles={['admin','data_entry']}><EditInstitution /></RoleGuard> },
{ path: "/dashboard/institutions/view/:id", component: <RoleGuard roles={['admin','data_entry','user']}><ViewInstitution /></RoleGuard> },
  { path: "/dashboard/institutions/print/:id", component: <RoleGuard roles={['admin','data_entry','user']}><PrintInstitutionView /></RoleGuard> },
  { path: "/dashboard/institutions/cards", component: <InstitutionsCards /> }, // السماح للجميع
  
  // Journalists Routes (admin + data_entry)
  { path: "/dashboard/journalists", component: <RoleGuard roles={['admin','data_entry']}><JournalistsList /></RoleGuard> },
  { path: "/dashboard/journalists/create", component: <RoleGuard roles={['admin','data_entry']}><CreateJournalist /></RoleGuard> },
  { path: "/dashboard/journalists/edit/:id", component: <RoleGuard roles={['admin','data_entry']}><EditJournalist /></RoleGuard> },
{ path: "/dashboard/journalists/view/:id", component: <RoleGuard roles={['admin','data_entry','user']}><ViewJournalist /></RoleGuard> },
  { path: "/dashboard/journalists/print/:id", component: <RoleGuard roles={['admin','data_entry','user']}><PrintJournalistView /></RoleGuard> },
  { path: "/dashboard/journalists/cards", component: <JournalistsCards /> }, // السماح للجميع
  
  // Activists Routes (admin + data_entry)
  { path: "/dashboard/activists", component: <RoleGuard roles={['admin','data_entry']}><ActivistsList /></RoleGuard> },
  { path: "/dashboard/activists/create", component: <RoleGuard roles={['admin','data_entry']}><CreateActivist /></RoleGuard> },
  { path: "/dashboard/activists/edit/:id", component: <RoleGuard roles={['admin','data_entry']}><EditActivist /></RoleGuard> },
{ path: "/dashboard/activists/view/:id", component: <RoleGuard roles={['admin','data_entry','user']}><ViewActivist /></RoleGuard> },  
  { path: "/dashboard/activists/print/:id", component: <RoleGuard roles={['admin','data_entry','user']}><PrintActivistView /></RoleGuard> },
  { path: "/dashboard/activists/cards", component: <ActivistsCards /> }, // السماح للجميع
  { path: "/dashboard/activists/user-view/:id", component: <RoleGuard roles={['admin','data_entry','user']}><UserViewActivist /></RoleGuard> },


  // Users Routes (admin فقط)
  { path: '/dashboard/users', component: <RoleGuard roles={['admin']}><UsersList /></RoleGuard> },
  { path: '/dashboard/users/create', component: <RoleGuard roles={['admin']}><UserCreate /></RoleGuard> },
  { path: '/dashboard/users/edit/:id', component: <RoleGuard roles={['admin']}><UserEdit /></RoleGuard> },

  // Approvals - Admin
  { path: '/dashboard/pending-approvals', component: <RoleGuard roles={['admin']}><PendingApprovals /></RoleGuard> },
  { path: '/dashboard/pending-approvals/:id', component: <RoleGuard roles={['admin']}><PendingApprovalDetail /></RoleGuard> },
  { path: '/dashboard/approval-logs', component: <RoleGuard roles={['admin']}><ApprovalLogs /></RoleGuard> },

  // My Requests - data_entry
  { path: '/dashboard/my-requests', component: <RoleGuard roles={['admin','data_entry']}><MyRequests /></RoleGuard> },

  // Settings
  { path: '/dashboard/settings/whitelist', component: <RoleGuard roles={['admin']}><Whitelist /></RoleGuard> },

  // this route should be at the end of all other routes
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/blocked", component: <BlockedIp /> },

  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
]

export { userRoutes, authRoutes }